import { useEffect } from 'react';

function setMeta(name: string, content: string, property?: boolean) {
  const attr = property ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export function useDocumentMeta({ title, description, jsonLd }: {
  title: string;
  description: string;
  jsonLd?: Record<string, unknown>;
}) {
  useEffect(() => {
    const prev = document.title;
    const suffix = ' | Learn Around Town';
    document.title = title.includes('Learn Around Town') ? title : title + suffix;
    setMeta('description', description);
    setMeta('og:title', document.title, true);
    setMeta('og:description', description, true);
    setMeta('og:url', window.location.href, true);

    let scriptEl: HTMLScriptElement | null = null;
    if (jsonLd) {
      scriptEl = document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(scriptEl);
    }

    return () => {
      document.title = prev;
      if (scriptEl) document.head.removeChild(scriptEl);
    };
  }, [title, description, jsonLd]);
}
